import { Icon, IconButton } from "@chakra-ui/react";

import type { ElementType } from "react";

interface MediaButtonProps {
	label: string;
	icon: ElementType;
	onClick: () => void;
}

export const MediaButton = (props: MediaButtonProps) => {
	const { icon, label, onClick } = props;
	return (
		<IconButton
			variant="unstyled"
			color="brand.light"
			onClick={onClick}
			aria-label={label}
			icon={<Icon as={icon} />}
			_hover={{ color: "brand.contrast" }}
			fontSize={{
				base: label === "play" ? "xl" : "2xl",
				md: label === "play" ? "2xl" : "3xl",
			}}
		/>
	);
};
